export default __webpack_public_path__ + "static/media/emptyState.7572990b.svg";